<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title font-weight-bold" id="exampleModalLabel1">
      Historial
    </h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      [mat-dialog-close]
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 mb-3">
        <div class="d-flex justify-content-center h-100">
          <div class="searchbar">
            <input
              class="search_input"
              type="text"
              [(ngModel)]="search"
              placeholder="Filtrar..."
            />
            <button class="search_icon" (click)="filter()">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="content-table tableSize" style="overflow: initial !important">
      <table
        mat-table
        #dataTable
        [dataSource]="dataSource"
        matSort
        style="width: 100%; --min-width: 600px"
        class="table-striped text-center"
      >
        <ng-container matColumnDef="usuario">
          <th
            class="header-options"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Usuario
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.usuario }}
          </td>
        </ng-container>

        <ng-container matColumnDef="realizado">
          <th
            class="header-options"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Realizado
          </th>
          <td
            mat-cell
            (click)="
              element.ver = element.ver == undefined ? true : !element.ver
            "
            style="cursor: pointer; display: flex"
            *matCellDef="let element"
          >
            {{
              element.ver ? element.realizo : element.realizo.substring(0, 60)
            }}
            <p
              *ngIf="!element.ver && element.realizo.length > 60"
              style="color: #00a2ff"
            >
              ...ver mas
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th
            class="header-options"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Dia de Creación
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.date | date : "dd/MM/yyy" }}
          </td>
        </ng-container>

        <tr mat-header-row></tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <mat-paginator
      [pageSizeOptions]="[5, 10]"
      [pageSize]="10"
      [showFirstLastButtons]
    ></mat-paginator>
  </div>
</div>
